import { forwardRef } from 'react'
import { IconProps } from '../Types'

export const FolderClosed = forwardRef<SVGSVGElement, IconProps>(
  ({ color = 'currentColor', size = 16 }, forwardedRef) => {
    return (
      <svg
        width={size}
        height={size}
        style={{ width: size, height: size }}
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        ref={forwardedRef}
      >
        <path
          d="M1.5 3.5C1.5 2.94772 1.94772 2.5 2.5 2.5H6.46482C6.79917 2.5 7.1114 2.6671 7.29687 2.9453L7.70313 3.5547C7.8886 3.8329 8.20083 4 8.53518 4H13.5C14.0523 4 14.5 4.44772 14.5 5C14.5 5.55228 14.0523 6 13.5 6H2.5C1.94772 6 1.5 5.55228 1.5 5L1.5 4.165L1.5 3.5Z"
          fill={color}
          fillOpacity="0.1"
        />
        <path
          d="M15 6H1V12C1 12.5523 1.44772 13 2 13H14C14.5523 13 15 12.5523 15 12V6Z"
          fill={color}
          fillOpacity="0.05"
        />
        <path
          d="M1.5 3C1.5 2.44771 1.94772 2 2.5 2L6.46482 2C6.79917 2 7.1114 2.1671 7.29687 2.4453L7.70313 3.0547C7.8886 3.3329 8.20083 3.5 8.53518 3.5H13.5C14.0523 3.5 14.5 3.94772 14.5 4.5V12.5C14.5 13.0523 14.0523 13.5 13.5 13.5L2.5 13.5C1.94772 13.5 1.5 13.0523 1.5 12.5L1.5 3.665L1.5 3Z"
          stroke={color}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M14.5 6H1.5V12.5C1.5 13.0523 1.94772 13.5 2.5 13.5H13.5C14.0523 13.5 14.5 13.0523 14.5 12.5V6Z"
          stroke={color}
        />
      </svg>
    )
  },
)

export default FolderClosed
